import React from 'react';
import { ReaderPathCheck } from './ReaderPathCheck';
import { Reveal } from './Reveal';
import { PathThread } from './PathThread';
export function ReaderValue() {
  const readerStates = ['Interested, but not ready for a call', 'Trying to apply one idea', 'Needs the right next step'];
  return <section className="py-24 px-6 max-w-4xl mx-auto relative" data-id="element-472">
      <div className="absolute -top-12 left-1/2 -translate-x-1/2" data-id="element-473">
        <PathThread data-id="element-474" />
      </div>

      <div className="text-center mb-20" data-id="element-475">
        <Reveal data-id="element-476">
          <h2 className="text-3xl md:text-5xl font-serif text-navy mb-8 leading-tight" data-id="element-477">
            Some readers are not ready to buy. <br data-id="element-478" />
            <span className="italic text-seaglass" data-id="element-479">
              But they are ready to keep going.
            </span>
          </h2>
        </Reveal>
        <Reveal delay={0.1} data-id="element-480">
          <div className="text-lg text-text-muted leading-relaxed max-w-2xl mx-auto space-y-6" data-id="element-481">
            <p data-id="element-482">
              A reader can be interested without being ready to book a call.
            </p>
            <ul className="space-y-3 text-left max-w-lg mx-auto bg-white p-6 rounded-2xl shadow-[0_8px_20px_-12px_rgba(26,40,56,0.1)] border border-gray-100" data-id="element-483">
              <li className="flex items-start gap-3" data-id="element-484">
                <div className="w-1.5 h-1.5 rounded-full bg-seaglass mt-2.5 flex-shrink-0" data-id="element-485"></div>
                They may need to understand where they fit.
              </li>
              <li className="flex items-start gap-3" data-id="element-486">
                <div className="w-1.5 h-1.5 rounded-full bg-seaglass mt-2.5 flex-shrink-0" data-id="element-487"></div>
                They may need to try the idea in their own situation.
              </li>
              <li className="flex items-start gap-3" data-id="element-488">
                <div className="w-1.5 h-1.5 rounded-full bg-seaglass mt-2.5 flex-shrink-0" data-id="element-489"></div>
                They may need to see whether the framework applies to their
                team.
              </li>
              <li className="flex items-start gap-3" data-id="element-490">
                <div className="w-1.5 h-1.5 rounded-full bg-seaglass mt-2.5 flex-shrink-0" data-id="element-491"></div>
                They may need language for the problem before they are ready to
                ask for help.
              </li>
            </ul>
            <p className="font-serif text-2xl text-navy pt-6" data-id="element-492">
              The path after the book gives them a useful next step before they
              are ready for a sales conversation.
            </p>
          </div>
        </Reveal>
      </div>

      <div className="grid md:grid-cols-3 gap-6 mb-24" data-id="element-493">
        {readerStates.map((state, idx) => <Reveal key={idx} delay={0.1 * idx} data-id="element-494">
            <div className="bg-white border border-gray-100 rounded-2xl p-8 text-center shadow-[0_12px_24px_-12px_rgba(26,40,56,0.15)] hover:-translate-y-1 transition-transform duration-300 flex items-center justify-center min-h-[120px]" data-id="element-495">
              <span className="font-serif text-lg text-navy" data-id="element-496">{state}</span>
            </div>
          </Reveal>)}
      </div>

      <Reveal delay={0.2} data-id="element-497">
        <div id="quick-check-3" className="scroll-mt-32" data-id="element-498">
          <ReaderPathCheck questionId="q4.apply.thisWeek" checkLabel="Quick Check · 3 of 8" confirmationText="Saved. This helps check whether the book gives readers a useful next step." data-id="element-499" />
        </div>
      </Reveal>
    </section>;
}